// react =>
import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

// componenets =>
import MessageBox from "../Components/messageBox/messageBox.comp";

interface Message {
    type: "error" | "success";
    text: string;
}

interface MessageContextType {
    showMessage: (type: 'error' | 'success', text: string) => void;
}

const MessageContext = createContext<MessageContextType | undefined>(undefined);

export const MessageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [message, setMessage] = useState<Message | null>(null);

    useEffect(() => {
        const savedMessage = localStorage.getItem('appMessage');
        if (savedMessage) {
            setMessage(JSON.parse(savedMessage));
            localStorage.removeItem('appMessage');
        }
    }, []);

    useEffect(() => {
        if (message) {
        const timer = setTimeout(() => {
            handleClose();
        }, 7000);

        return () => clearTimeout(timer);
        }
    }, [message]);

    const showMessage = (type: 'error' | 'success', text: string) => {
        const newMessage = { type, text };
        setMessage(newMessage);
        localStorage.setItem('appMessage', JSON.stringify(newMessage));
    };

    const handleClose = () => {
        setMessage(null);
        localStorage.removeItem('appMessage');
    };

    return (
        <MessageContext.Provider value={{ showMessage }}>
        {children}
        {message && (
            <MessageBox
            messageType={ message.type }
            messageText={ message.text }
            onClose={ handleClose }
            />
        )}
        </MessageContext.Provider>
    );
};

export const useMessage = () => {
    const context = useContext(MessageContext);
    if (!context) {
        throw new Error('useMessage must be used within a MessageProvider');
    }
    return context;
};
